import React from "react";

import { useLocation, Link, useNavigate } from "react-router-dom";

import aeonLogo from "../assets/images/aeonLogo.png";
import { useStateContext } from "../contexts/ContextProvider";

const Sidebar = ({ isLoggedIn, setIsLoggedIn, user }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const { setShowMenu } = useStateContext();

  const handleLogout = () => {
    setIsLoggedIn(false);
    navigate("/login");
    window.location.reload();
    localStorage.clear();
    navigate("/login");
  };

  const isActiveDashboard =
    location.pathname.includes("/dashboard") || location.pathname === "/";

  const isActiveRetentionDashboard = location.pathname.includes(
    "/retention_dashboard",
  );

  const isHolidayShift =
    location.pathname.includes("/holidayShift") ||
    location.pathname.includes("/HolidayShiftDetails");

  const isActiveLeaveHistory =
    location.pathname.includes("/leaveHistory") ||
    location.pathname.includes("/leaveDetails");

  const isActiveLeaveOverview = location.pathname.includes("/leaveOverview");

  const isActiveDailyLogs = location.pathname.includes("/dailyLogs");

  const isActiveCompanyPolicies =
    location.pathname.includes("/companyPolicies");

  const isActiveLeaveRequest =
    location.pathname.includes("/leaveRequest") ||
    location.pathname.includes("/empLeaveDetails");

  const isActiveLeaveReconcile =
    location.pathname.includes("/leaveReconcile") ||
    location.pathname.includes("/leaveReconcileDetails");

  const isActiveEmployees =
    location.pathname.includes("/employees") ||
    location.pathname.includes("/addemployee") ||
    location.pathname.includes("/empLeaveHistory");

  const isActiveCompanyHierarchy =
    location.pathname.includes("/companyHierarchy");
  const isActiveLeaveConfiguration = location.pathname.includes(
    "/leaveConfiguration",
  );
  const isActiveReports = location.pathname.includes("/reports");

  const isActiveHolidayList = location.pathname.includes("/holidayList");

  const isActiveTeam =
    location.pathname.includes("/team") ||
    location.pathname.includes("/empLeaveHistory");

  return (
    <>
      <div className="sidebar">
        <div className="close-menu" onClick={() => setShowMenu(false)}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="#ffffff"
            className="bi bi-x"
            viewBox="0 0 16 16"
          >
            <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
          </svg>
        </div>
        <div className="logo">
          <img src={aeonLogo} alt="aeonLogo" />
        </div>
        <div className="sidebar-links">
          <ul>
            <li className={isActiveDashboard ? "active" : ""}>
              <Link to="/dashboard" className="navLink">
                <svg
                  width="22"
                  height="22"
                  viewBox="0 0 22 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    className="stroke"
                    d="M3.66797 4.58329C3.66797 4.34018 3.76455 4.10702 3.93645 3.93511C4.10836 3.7632 4.34152 3.66663 4.58464 3.66663H8.2513C8.49442 3.66663 8.72757 3.7632 8.89948 3.93511C9.07139 4.10702 9.16797 4.34018 9.16797 4.58329V9.16663C9.16797 9.40974 9.07139 9.6429 8.89948 9.81481C8.72757 9.98672 8.49442 10.0833 8.2513 10.0833H4.58464C4.34152 10.0833 4.10836 9.98672 3.93645 9.81481C3.76455 9.6429 3.66797 9.40974 3.66797 9.16663V4.58329ZM12.8346 4.58329C12.8346 4.34018 12.9312 4.10702 13.1031 3.93511C13.275 3.7632 13.5082 3.66663 13.7513 3.66663H17.418C17.6611 3.66663 17.8942 3.7632 18.0662 3.93511C18.2381 4.10702 18.3346 4.34018 18.3346 4.58329V6.41663C18.3346 6.65974 18.2381 6.8929 18.0662 7.06481C17.8942 7.23672 17.6611 7.33329 17.418 7.33329H13.7513C13.5082 7.33329 13.275 7.23672 13.1031 7.06481C12.9312 6.8929 12.8346 6.65974 12.8346 6.41663V4.58329ZM3.66797 14.6666C3.66797 14.4235 3.76455 14.1904 3.93645 14.0184C4.10836 13.8465 4.34152 13.75 4.58464 13.75H8.2513C8.49442 13.75 8.72757 13.8465 8.89948 14.0184C9.07139 14.1904 9.16797 14.4235 9.16797 14.6666V17.4166C9.16797 17.6597 9.07139 17.8929 8.89948 18.0648C8.72757 18.2367 8.49442 18.3333 8.2513 18.3333H4.58464C4.34152 18.3333 4.10836 18.2367 3.93645 18.0648C3.76455 17.8929 3.66797 17.6597 3.66797 17.4166V14.6666ZM12.8346 11.9166C12.8346 11.6735 12.9312 11.4404 13.1031 11.2684C13.275 11.0965 13.5082 11 13.7513 11H17.418C17.6611 11 17.8942 11.0965 18.0662 11.2684C18.2381 11.4404 18.3346 11.6735 18.3346 11.9166V17.4166C18.3346 17.6597 18.2381 17.8929 18.0662 18.0648C17.8942 18.2367 17.6611 18.3333 17.418 18.3333H13.7513C13.5082 18.3333 13.275 18.2367 13.1031 18.0648C12.9312 17.8929 12.8346 17.6597 12.8346 17.4166V11.9166Z"
                    strokeWidth="1.5"
                  />
                </svg>

                <span>Dashboard</span>
              </Link>
            </li>
            {/* 
            {(user.designation === "BDM" ||
              (user.role === "1" && user.role === "4")) && ( */}
            <li className={isActiveRetentionDashboard ? "active" : ""}>
              <Link to="/retention_dashboard" className="navLink">
                <svg
                  width="22"
                  height="22"
                  viewBox="0 0 22 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    className="stroke"
                    d="M2.75 18.3333H19.25"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    className="stroke"
                    d="M3.66699 14.6667L8.25033 10.0833L11.917 13.75L18.3337 7.33333"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    className="stroke"
                    d="M13.75 7.33333H18.3337V12.3333"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>

                <span>Retention Dashboard</span>
              </Link>
            </li>
            {/* )} */}

            {user.role !== "4" ? (
              <>
                <li className={isActiveLeaveHistory ? "active" : ""}>
                  <Link to="/leaveHistory" className="navLink">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M3 9H21M7 3V5M17 3V5M11.9976 12.7119C11.2978 11.9328 10.1309 11.7232 9.25414 12.4367C8.37738 13.1501 8.25394 14.343 8.94247 15.1868C9.33119 15.6632 10.2548 16.4983 10.9854 17.1353C11.3319 17.4374 11.5051 17.5885 11.7147 17.6503C11.8934 17.703 12.1018 17.703 12.2805 17.6503C12.4901 17.5885 12.6633 17.4374 13.0098 17.1353C13.7404 16.4983 14.664 15.6632 15.0527 15.1868C15.7413 14.343 15.6329 13.1426 14.7411 12.4367C13.8492 11.7307 12.6974 11.9328 11.9976 12.7119ZM6.2 21H17.8C18.9201 21 19.4802 21 19.908 20.782C20.2843 20.5903 20.5903 20.2843 20.782 19.908C21 19.4802 21 18.9201 21 17.8V8.2C21 7.07989 21 6.51984 20.782 6.09202C20.5903 5.71569 20.2843 5.40973 19.908 5.21799C19.4802 5 18.9201 5 17.8 5H6.2C5.0799 5 4.51984 5 4.09202 5.21799C3.71569 5.40973 3.40973 5.71569 3.21799 6.09202C3 6.51984 3 7.07989 3 8.2V17.8C3 18.9201 3 19.4802 3.21799 19.908C3.40973 20.2843 3.71569 20.5903 4.09202 20.782C4.51984 21 5.07989 21 6.2 21Z"
                        className="stroke"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>

                    <span>Leave History</span>
                  </Link>
                </li>
              </>
            ) : null}

            {user.role === "1" || user.role === "2" || user.role === "4" ? (
              <>
                {" "}
                <li className={isActiveLeaveRequest ? "active" : ""}>
                  <Link to="/leaveRequest" className="navLink">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M11 14H3"
                        strokeWidth="1.4"
                        strokeLinecap="round"
                        className="stroke"
                      />
                      <path
                        d="M11 18H3"
                        strokeWidth="1.4"
                        strokeLinecap="round"
                        className="stroke"
                      />
                      <path
                        d="M20 16.5L17.5 14M17.5 14L15 16.5M17.5 14V20"
                        strokeWidth="1.4"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="stroke"
                      />
                      <path
                        d="M3 6H13.5M20 6H17.75"
                        strokeWidth="1.4"
                        strokeLinecap="round"
                        className="stroke"
                      />
                      <path
                        d="M20 10H9.5M3 10H5.25"
                        strokeWidth="1.4"
                        strokeLinecap="round"
                        className="stroke"
                      />
                    </svg>

                    <span>Leave Request</span>
                  </Link>
                </li>
              </>
            ) : null}

            {user.role === "1" || user.role === "4" ? (
              <>
                <li className={isActiveLeaveReconcile ? "active" : ""}>
                  <Link to="/leaveReconcile" className="navLink">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M11 14H3"
                        strokeWidth="1.4"
                        strokeLinecap="round"
                        className="stroke"
                      />
                      <path
                        d="M11 18H3"
                        strokeWidth="1.4"
                        strokeLinecap="round"
                        className="stroke"
                      />
                      <path
                        d="M20 16.5L17.5 14M17.5 14L15 16.5M17.5 14V20"
                        strokeWidth="1.4"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="stroke"
                      />
                      <path
                        d="M3 6H13.5M20 6H17.75"
                        strokeWidth="1.4"
                        strokeLinecap="round"
                        className="stroke"
                      />
                      <path
                        d="M20 10H9.5M3 10H5.25"
                        strokeWidth="1.4"
                        strokeLinecap="round"
                        className="stroke"
                      />
                    </svg>

                    <span>Leave Reconcilation</span>
                  </Link>
                </li>
              </>
            ) : null}

            {user.role === "1" ? (
              <>
                <li className={isActiveLeaveOverview ? "active" : ""}>
                  <Link to="/leaveOverview" className="navLink">
                    <svg
                      width="22"
                      height="22"
                      viewBox="0 0 22 22"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M10.3112 1.83337C10.3112 1.45368 10.619 1.14587 10.9987 1.14587C16.441 1.14587 20.8529 5.55774 20.8529 11C20.8529 16.4424 16.441 20.8542 10.9987 20.8542C5.55639 20.8542 1.14453 16.4424 1.14453 11C1.14453 10.6204 1.45234 10.3125 1.83203 10.3125C2.21172 10.3125 2.51953 10.6204 2.51953 11C2.51953 15.6829 6.31579 19.4792 10.9987 19.4792C15.6816 19.4792 19.4779 15.6829 19.4779 11C19.4779 6.31713 15.6816 2.52087 10.9987 2.52087C10.619 2.52087 10.3112 2.21307 10.3112 1.83337ZM10.9987 7.56254C11.3784 7.56254 11.6862 7.87035 11.6862 8.25004V11.2292H14.6654C15.045 11.2292 15.3529 11.537 15.3529 11.9167C15.3529 12.2964 15.045 12.6042 14.6654 12.6042H10.9987C10.619 12.6042 10.3112 12.2964 10.3112 11.9167V8.25004C10.3112 7.87035 10.619 7.56254 10.9987 7.56254Z"
                        className="fill"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M8.34145 2.19779C8.47818 2.55201 8.30188 2.95001 7.94766 3.08675C7.81801 3.1368 7.6899 3.18994 7.5634 3.24609C7.21636 3.40016 6.81014 3.24373 6.65609 2.89669C6.50202 2.54966 6.65845 2.14344 7.00549 1.98937C7.15262 1.92406 7.30166 1.86223 7.45249 1.804C7.80672 1.66726 8.20471 1.84358 8.34145 2.19779ZM5.17723 3.88695C5.43909 4.16191 5.42847 4.59709 5.15352 4.85894C5.05298 4.95469 4.9548 5.05286 4.85906 5.15339C4.59721 5.42835 4.16203 5.43897 3.88708 5.17711C3.61212 4.91525 3.60151 4.48008 3.86336 4.20513C3.97453 4.08841 4.08852 3.9744 4.20525 3.86324C4.48021 3.60138 4.91537 3.612 5.17723 3.88695ZM2.89681 6.65597C3.24385 6.81003 3.40028 7.21625 3.24622 7.56328C3.19006 7.68977 3.13692 7.81789 3.08687 7.94754C2.95013 8.30176 2.55213 8.47806 2.19792 8.34133C1.8437 8.20459 1.66739 7.80659 1.80413 7.45238C1.86235 7.30154 1.92418 7.1525 1.98949 7.00537C2.14356 6.65833 2.54978 6.5019 2.89681 6.65597Z"
                        className="fill"
                      />
                    </svg>

                    <span>Leave Overview</span>
                  </Link>
                </li>
              </>
            ) : null}

            <li className={isHolidayShift ? "active" : ""}>
              <Link to="/holidayShift" className="navLink">
                <svg
                  width="22"
                  height="22"
                  viewBox="0 0 22 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_1548_1543)">
                    <path
                      className="fill"
                      d="M5.58304 7.03675C6.83278 7.03675 7.84952 6.02001 7.84952 4.77027C7.84952 3.52046 6.83278 2.50372 5.58304 2.50372C4.33324 2.50372 3.3165 3.52046 3.3165 4.77027C3.3165 6.02001 4.3333 7.03675 5.58304 7.03675ZM5.58304 3.59082C6.23337 3.59082 6.76242 4.11994 6.76242 4.77027C6.76242 5.42059 6.23337 5.94965 5.58304 5.94965C4.93265 5.94965 4.4036 5.42059 4.4036 4.77027C4.4036 4.11988 4.93271 3.59082 5.58304 3.59082ZM11.4911 16.0905V18.9528C11.4911 19.253 11.2478 19.4964 10.9476 19.4964H2.42411C2.12389 19.4964 1.88056 19.253 1.88056 18.9528V18.3172C1.88056 18.0169 2.12389 17.7736 2.42411 17.7736C2.72433 17.7736 2.96766 18.0169 2.96766 18.3172V18.4093H10.404V16.6341H4.6029C4.30268 16.6341 4.05935 16.3908 4.05935 16.0905C4.05935 15.7903 4.30268 15.547 4.6029 15.547H10.9476C11.2478 15.547 11.4911 15.7904 11.4911 16.0905ZM21.4564 13.1977H16.391V11.8825H20.3672C20.6675 11.8825 20.9108 11.6392 20.9108 11.3389V5.42029C20.9108 5.12007 20.6675 4.87674 20.3672 4.87674H11.3278C11.0276 4.87674 10.7843 5.12007 10.7843 5.42029V11.3389C10.7843 11.6392 11.0276 11.8825 11.3278 11.8825H15.304V13.1977H2.9159L2.97871 11.0991C2.9975 10.4713 3.20549 9.00923 4.72719 8.99377C4.7368 8.99371 4.74634 8.99335 4.75582 8.99274C4.76772 8.99353 4.77974 8.99395 4.79188 8.99395H6.44439C6.4459 8.99395 6.44747 8.99395 6.44904 8.99395C7.96156 9.01569 8.16865 10.4727 8.18743 11.0992C8.19643 11.3993 8.44695 11.6348 8.74705 11.6263C9.04715 11.6173 9.28305 11.3668 9.27411 11.0667C9.21704 9.16396 8.1085 7.92364 6.45 7.90679C6.44427 7.90667 6.43865 7.90679 6.43291 7.90685H4.79188C4.78046 7.90685 4.76905 7.90721 4.75775 7.90794C4.74398 7.90703 4.73009 7.90661 4.7162 7.90679C3.05759 7.92364 1.94911 9.16396 1.89216 11.0667L1.82838 13.1978H0.54355C0.243329 13.1978 0 13.4411 0 13.7413C0 14.0415 0.243329 14.2849 0.54355 14.2849H1.79577L1.76442 15.3313C1.75548 15.6313 1.99139 15.8818 2.29149 15.8908C2.29704 15.8909 2.30254 15.8911 2.30803 15.8911C2.6007 15.8911 2.84222 15.6583 2.85104 15.3637L2.88335 14.2849H15.8363C15.8437 14.285 15.8513 14.285 15.8587 14.2849H21.4564C21.7567 14.2849 22 14.0415 22 13.7413C22 13.4411 21.7567 13.1977 21.4564 13.1977ZM11.8714 10.7954V5.96384H19.8237V10.7954H11.8714Z"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_1548_1543">
                      <rect width="22" height="22" className="fill" />
                    </clipPath>
                  </defs>
                </svg>

                <span>Holiday Shift</span>
              </Link>
            </li>

            {user.role === "1" || user.role === "4" ? (
              <>
                <li className={isActiveEmployees ? "active" : ""}>
                  <Link to="/employees" className="navLink">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clipPath="url(#clip0_364_2773)">
                        <path
                          d="M6.971 8.95457C8.2067 8.95457 9.30621 8.36184 10.0013 7.44615C10.6964 8.36184 11.7959 8.95457 13.0316 8.95457C15.1286 8.95457 16.8346 7.24857 16.8346 5.15154C16.8346 3.05451 15.1286 1.34851 13.0316 1.34851C11.7959 1.34851 10.6964 1.94124 10.0013 2.85693C9.30621 1.94124 8.2067 1.34851 6.971 1.34851C4.87397 1.34851 3.16797 3.05451 3.16797 5.15154C3.16797 7.24857 4.87397 8.95457 6.971 8.95457ZM13.0316 3.16669C14.1261 3.16669 15.0165 4.05706 15.0165 5.15154C15.0165 6.24603 14.1261 7.13639 13.0316 7.13639C11.9371 7.13639 11.0468 6.24603 11.0468 5.15154C11.0468 4.05706 11.9371 3.16669 13.0316 3.16669ZM6.971 3.16669C8.06548 3.16669 8.95585 4.05706 8.95585 5.15154C8.95585 6.24603 8.06548 7.13639 6.971 7.13639C5.87651 7.13639 4.98615 6.24603 4.98615 5.15154C4.98615 4.05706 5.87651 3.16669 6.971 3.16669Z"
                          className="fill"
                        />
                        <path
                          d="M13.0303 10.7727C11.9774 10.7727 10.9395 11.0116 9.99867 11.466C9.08218 11.022 8.05455 10.7727 6.9697 10.7727C3.12661 10.7727 0 13.8993 0 17.7424C0 18.2445 0.40703 18.6515 0.909091 18.6515H13.0303H19.0909C19.593 18.6515 20 18.2445 20 17.7424C20 13.8993 16.8734 10.7727 13.0303 10.7727ZM1.89848 16.8333C2.32915 14.4249 4.43927 12.5909 6.9697 12.5909C9.50012 12.5909 11.6102 14.4249 12.0409 16.8333H1.89848ZM13.8801 16.8333C13.671 15.2349 12.9181 13.8054 11.8139 12.7365C12.2102 12.6406 12.6185 12.5909 13.0302 12.5909C15.5606 12.5909 17.6708 14.4249 18.1015 16.8333H13.8801Z"
                          className="fill"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_364_2773">
                          <rect width="20" height="20" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>

                    <span>Employees</span>
                  </Link>
                </li>
              </>
            ) : user.role === "2" ? (
              <>
                <li className={isActiveTeam ? "active" : ""}>
                  <Link to="/team" className="navLink">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clipPath="url(#clip0_364_2773)">
                        <path
                          d="M6.971 8.95457C8.2067 8.95457 9.30621 8.36184 10.0013 7.44615C10.6964 8.36184 11.7959 8.95457 13.0316 8.95457C15.1286 8.95457 16.8346 7.24857 16.8346 5.15154C16.8346 3.05451 15.1286 1.34851 13.0316 1.34851C11.7959 1.34851 10.6964 1.94124 10.0013 2.85693C9.30621 1.94124 8.2067 1.34851 6.971 1.34851C4.87397 1.34851 3.16797 3.05451 3.16797 5.15154C3.16797 7.24857 4.87397 8.95457 6.971 8.95457ZM13.0316 3.16669C14.1261 3.16669 15.0165 4.05706 15.0165 5.15154C15.0165 6.24603 14.1261 7.13639 13.0316 7.13639C11.9371 7.13639 11.0468 6.24603 11.0468 5.15154C11.0468 4.05706 11.9371 3.16669 13.0316 3.16669ZM6.971 3.16669C8.06548 3.16669 8.95585 4.05706 8.95585 5.15154C8.95585 6.24603 8.06548 7.13639 6.971 7.13639C5.87651 7.13639 4.98615 6.24603 4.98615 5.15154C4.98615 4.05706 5.87651 3.16669 6.971 3.16669Z"
                          className="fill"
                        />
                        <path
                          d="M13.0303 10.7727C11.9774 10.7727 10.9395 11.0116 9.99867 11.466C9.08218 11.022 8.05455 10.7727 6.9697 10.7727C3.12661 10.7727 0 13.8993 0 17.7424C0 18.2445 0.40703 18.6515 0.909091 18.6515H13.0303H19.0909C19.593 18.6515 20 18.2445 20 17.7424C20 13.8993 16.8734 10.7727 13.0303 10.7727ZM1.89848 16.8333C2.32915 14.4249 4.43927 12.5909 6.9697 12.5909C9.50012 12.5909 11.6102 14.4249 12.0409 16.8333H1.89848ZM13.8801 16.8333C13.671 15.2349 12.9181 13.8054 11.8139 12.7365C12.2102 12.6406 12.6185 12.5909 13.0302 12.5909C15.5606 12.5909 17.6708 14.4249 18.1015 16.8333H13.8801Z"
                          className="fill"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_364_2773">
                          <rect width="20" height="20" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>

                    <span>Team</span>
                  </Link>
                </li>
              </>
            ) : null}

            <li className={isActiveDailyLogs ? "active" : ""}>
              <Link to="/dailyLogs" className="navLink">
                <svg
                  width="22"
                  height="22"
                  viewBox="0 0 22 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.30675 1.72701C7.48681 1.93273 7.57782 2.20152 7.55977 2.47431C7.54173 2.74711 7.4161 3.00157 7.2105 3.18176L5.34737 4.81251L7.2105 6.44326C7.31633 6.53128 7.40347 6.63959 7.46678 6.76181C7.53009 6.88403 7.56829 7.01769 7.57914 7.15491C7.58998 7.29213 7.57324 7.43012 7.52991 7.56077C7.48658 7.69142 7.41754 7.81207 7.32685 7.91562C7.23615 8.01916 7.12565 8.1035 7.00185 8.16366C6.87805 8.22383 6.74346 8.2586 6.60601 8.26593C6.46856 8.27326 6.33103 8.253 6.20153 8.20634C6.07204 8.15968 5.95319 8.08758 5.852 7.99426L3.102 5.58801C2.99158 5.49123 2.9031 5.37197 2.84249 5.23823C2.78187 5.10449 2.75051 4.95935 2.75051 4.81251C2.75051 4.66568 2.78187 4.52054 2.84249 4.3868C2.9031 4.25306 2.99158 4.1338 3.102 4.03701L5.852 1.63076C6.05771 1.4507 6.32651 1.35969 6.5993 1.37774C6.87209 1.39579 7.12655 1.52142 7.30675 1.72701ZM9.88075 1.72701C9.70069 1.93273 9.60968 2.20152 9.62773 2.47431C9.64577 2.74711 9.7714 3.00157 9.977 3.18176L11.8401 4.81251L9.977 6.44326C9.87117 6.53128 9.78403 6.63959 9.72072 6.76181C9.65741 6.88403 9.61921 7.01769 9.60836 7.15491C9.59752 7.29213 9.61426 7.43012 9.65759 7.56077C9.70092 7.69142 9.76996 7.81207 9.86065 7.91562C9.95135 8.01916 10.0618 8.1035 10.1856 8.16366C10.3095 8.22383 10.444 8.2586 10.5815 8.26593C10.7189 8.27326 10.8565 8.253 10.986 8.20634C11.1155 8.15968 11.2343 8.08758 11.3355 7.99426L14.0855 5.58801C14.1959 5.49123 14.2844 5.37197 14.345 5.23823C14.4056 5.10449 14.437 4.95935 14.437 4.81251C14.437 4.66568 14.4056 4.52054 14.345 4.3868C14.2844 4.25306 14.1959 4.1338 14.0855 4.03701L11.3355 1.63076C11.1298 1.4507 10.861 1.35969 10.5882 1.37774C10.3154 1.39579 10.0609 1.52142 9.88075 1.72701ZM3.78125 10.3125C3.50775 10.3125 3.24544 10.4212 3.05205 10.6146C2.85865 10.808 2.75 11.0703 2.75 11.3438C2.75 11.6173 2.85865 11.8796 3.05205 12.073C3.24544 12.2664 3.50775 12.375 3.78125 12.375H18.2188C18.4923 12.375 18.7546 12.2664 18.948 12.073C19.1413 11.8796 19.25 11.6173 19.25 11.3438C19.25 11.0703 19.1413 10.808 18.948 10.6146C18.7546 10.4212 18.4923 10.3125 18.2188 10.3125H3.78125ZM2.75 15.4688C2.75 15.1953 2.85865 14.933 3.05205 14.7396C3.24544 14.5462 3.50775 14.4375 3.78125 14.4375H18.2188C18.4923 14.4375 18.7546 14.5462 18.948 14.7396C19.1413 14.933 19.25 15.1953 19.25 15.4688C19.25 15.7423 19.1413 16.0046 18.948 16.198C18.7546 16.3914 18.4923 16.5 18.2188 16.5H3.78125C3.50775 16.5 3.24544 16.3914 3.05205 16.198C2.85865 16.0046 2.75 15.7423 2.75 15.4688ZM3.78125 18.5625C3.50775 18.5625 3.24544 18.6712 3.05205 18.8646C2.85865 19.058 2.75 19.3203 2.75 19.5938C2.75 19.8673 2.85865 20.1296 3.05205 20.323C3.24544 20.5164 3.50775 20.625 3.78125 20.625H12.7188C12.9923 20.625 13.2546 20.5164 13.448 20.323C13.6413 20.1296 13.75 19.8673 13.75 19.5938C13.75 19.3203 13.6413 19.058 13.448 18.8646C13.2546 18.6712 12.9923 18.5625 12.7188 18.5625H3.78125Z"
                    className="fill"
                  />
                </svg>

                <span>Daily Logs</span>
              </Link>
            </li>
            <li className={isActiveCompanyPolicies ? "active" : ""}>
              <Link to="/companyPolicies" className="navLink">
                <svg
                  width="22"
                  height="22"
                  viewBox="0 0 22 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13.75 10.2361C13.75 10.2361 13.4696 10.2361 13.4063 10.2361C12.4672 10.2361 11.6487 9.85645 11 9.16675C10.3513 9.85645 9.53288 10.2361 8.59379 10.2361C8.53046 10.2361 8.25004 10.2361 8.25004 10.2361C8.25004 10.2361 8.25 10.9491 8.25 11.3648C8.25 13.3944 9.41857 15.0999 11 15.5834C12.5814 15.0999 13.75 13.3944 13.75 11.3648C13.75 10.9491 13.75 10.2361 13.75 10.2361Z"
                    className="stroke"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M2.75 11.1194V13.3834C2.75 15.437 2.75 16.4637 3.14964 17.248C3.50118 17.938 4.06211 18.4989 4.75204 18.8504C5.53638 19.2501 6.56314 19.2501 8.61667 19.2501H13.3833C15.4369 19.2501 16.4636 19.2501 17.248 18.8504C17.9379 18.4989 18.4988 17.938 18.8503 17.248C19.25 16.4637 19.25 15.437 19.25 13.3834V11.1194C19.25 10.0664 19.25 9.53985 19.1142 9.05502C18.9941 8.62553 18.7965 8.22158 18.5312 7.86299C18.2319 7.4582 17.8163 7.13496 16.9851 6.48849L14.6018 4.63479C13.3136 3.63286 12.6695 3.1319 11.9583 2.93933C11.3307 2.76941 10.6693 2.76941 10.0417 2.93933C9.33048 3.1319 8.68641 3.63286 7.39821 4.63479L5.01488 6.48849C4.1837 7.13496 3.76811 7.4582 3.46871 7.86299C3.2035 8.22158 3.00593 8.62553 2.88571 9.05502C2.75 9.53985 2.75 10.0664 2.75 11.1194Z"
                    className="stroke"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>

                <span>Company Policies</span>
              </Link>
            </li>

            <li className={isActiveHolidayList ? "active" : ""}>
              <Link to="/holidayList" className="navLink">
                <svg
                  width="22"
                  height="22"
                  viewBox="0 0 22 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.30675 1.72701C7.48681 1.93273 7.57782 2.20152 7.55977 2.47431C7.54173 2.74711 7.4161 3.00157 7.2105 3.18176L5.34737 4.81251L7.2105 6.44326C7.31633 6.53128 7.40347 6.63959 7.46678 6.76181C7.53009 6.88403 7.56829 7.01769 7.57914 7.15491C7.58998 7.29213 7.57324 7.43012 7.52991 7.56077C7.48658 7.69142 7.41754 7.81207 7.32685 7.91562C7.23615 8.01916 7.12565 8.1035 7.00185 8.16366C6.87805 8.22383 6.74346 8.2586 6.60601 8.26593C6.46856 8.27326 6.33103 8.253 6.20153 8.20634C6.07204 8.15968 5.95319 8.08758 5.852 7.99426L3.102 5.58801C2.99158 5.49123 2.9031 5.37197 2.84249 5.23823C2.78187 5.10449 2.75051 4.95935 2.75051 4.81251C2.75051 4.66568 2.78187 4.52054 2.84249 4.3868C2.9031 4.25306 2.99158 4.1338 3.102 4.03701L5.852 1.63076C6.05771 1.4507 6.32651 1.35969 6.5993 1.37774C6.87209 1.39579 7.12655 1.52142 7.30675 1.72701ZM9.88075 1.72701C9.70069 1.93273 9.60968 2.20152 9.62773 2.47431C9.64577 2.74711 9.7714 3.00157 9.977 3.18176L11.8401 4.81251L9.977 6.44326C9.87117 6.53128 9.78403 6.63959 9.72072 6.76181C9.65741 6.88403 9.61921 7.01769 9.60836 7.15491C9.59752 7.29213 9.61426 7.43012 9.65759 7.56077C9.70092 7.69142 9.76996 7.81207 9.86065 7.91562C9.95135 8.01916 10.0618 8.1035 10.1856 8.16366C10.3095 8.22383 10.444 8.2586 10.5815 8.26593C10.7189 8.27326 10.8565 8.253 10.986 8.20634C11.1155 8.15968 11.2343 8.08758 11.3355 7.99426L14.0855 5.58801C14.1959 5.49123 14.2844 5.37197 14.345 5.23823C14.4056 5.10449 14.437 4.95935 14.437 4.81251C14.437 4.66568 14.4056 4.52054 14.345 4.3868C14.2844 4.25306 14.1959 4.1338 14.0855 4.03701L11.3355 1.63076C11.1298 1.4507 10.861 1.35969 10.5882 1.37774C10.3154 1.39579 10.0609 1.52142 9.88075 1.72701ZM3.78125 10.3125C3.50775 10.3125 3.24544 10.4212 3.05205 10.6146C2.85865 10.808 2.75 11.0703 2.75 11.3438C2.75 11.6173 2.85865 11.8796 3.05205 12.073C3.24544 12.2664 3.50775 12.375 3.78125 12.375H18.2188C18.4923 12.375 18.7546 12.2664 18.948 12.073C19.1413 11.8796 19.25 11.6173 19.25 11.3438C19.25 11.0703 19.1413 10.808 18.948 10.6146C18.7546 10.4212 18.4923 10.3125 18.2188 10.3125H3.78125ZM2.75 15.4688C2.75 15.1953 2.85865 14.933 3.05205 14.7396C3.24544 14.5462 3.50775 14.4375 3.78125 14.4375H18.2188C18.4923 14.4375 18.7546 14.5462 18.948 14.7396C19.1413 14.933 19.25 15.1953 19.25 15.4688C19.25 15.7423 19.1413 16.0046 18.948 16.198C18.7546 16.3914 18.4923 16.5 18.2188 16.5H3.78125C3.50775 16.5 3.24544 16.3914 3.05205 16.198C2.85865 16.0046 2.75 15.7423 2.75 15.4688ZM3.78125 18.5625C3.50775 18.5625 3.24544 18.6712 3.05205 18.8646C2.85865 19.058 2.75 19.3203 2.75 19.5938C2.75 19.8673 2.85865 20.1296 3.05205 20.323C3.24544 20.5164 3.50775 20.625 3.78125 20.625H12.7188C12.9923 20.625 13.2546 20.5164 13.448 20.323C13.6413 20.1296 13.75 19.8673 13.75 19.5938C13.75 19.3203 13.6413 19.058 13.448 18.8646C13.2546 18.6712 12.9923 18.5625 12.7188 18.5625H3.78125Z"
                    className="fill"
                  />
                </svg>

                <span>Holiday List</span>
              </Link>
            </li>

            {user.role === "1" || user.role === "4" ? (
              <>
                {/* <li className={isActiveLeaveConfiguration ? "active" : ""}>
                  <Link to="/leaveConfiguration" className="navLink">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M1.66797 15C1.66797 14.2234 1.66797 13.8352 1.79484 13.5288C1.96399 13.1205 2.28845 12.796 2.69683 12.6268C3.00312 12.5 3.3914 12.5 4.16797 12.5H15.8346C16.6112 12.5 16.9995 12.5 17.3058 12.6268C17.7141 12.796 18.0386 13.1205 18.2078 13.5288C18.3346 13.8352 18.3346 14.2234 18.3346 15C18.3346 15.7766 18.3346 16.1648 18.2078 16.4712C18.0386 16.8795 17.7141 17.204 17.3058 17.3732C16.9995 17.5 16.6112 17.5 15.8346 17.5H4.16797C3.3914 17.5 3.00312 17.5 2.69683 17.3732C2.28845 17.204 1.96399 16.8795 1.79484 16.4712C1.66797 16.1648 1.66797 15.7766 1.66797 15Z"
                        className="stroke"
                        strokeWidth="1.6"
                      />
                      <path
                        d="M1.66797 10C1.66797 9.22342 1.66797 8.83517 1.79484 8.52883C1.96399 8.12048 2.28845 7.79602 2.69683 7.62687C3.00312 7.5 3.3914 7.5 4.16797 7.5H15.8346C16.6112 7.5 16.9995 7.5 17.3058 7.62687C17.7141 7.79602 18.0386 8.12048 18.2078 8.52883C18.3346 8.83517 18.3346 9.22342 18.3346 10C18.3346 10.7766 18.3346 11.1648 18.2078 11.4712C18.0386 11.8795 17.7141 12.204 17.3058 12.3732C16.9995 12.5 16.6112 12.5 15.8346 12.5H4.16797C3.3914 12.5 3.00312 12.5 2.69683 12.3732C2.28845 12.204 1.96399 11.8795 1.79484 11.4712C1.66797 11.1648 1.66797 10.7766 1.66797 10Z"
                        className="stroke"
                        strokeWidth="1.6"
                      />
                      <path
                        d="M1.66797 5C1.66797 4.22343 1.66797 3.83515 1.79484 3.52886C1.96399 3.12048 2.28845 2.79603 2.69683 2.62687C3.00312 2.5 3.3914 2.5 4.16797 2.5H15.8346C16.6112 2.5 16.9995 2.5 17.3058 2.62687C17.7141 2.79603 18.0386 3.12048 18.2078 3.52886C18.3346 3.83515 18.3346 4.22343 18.3346 5C18.3346 5.77657 18.3346 6.16485 18.2078 6.47114C18.0386 6.87952 17.7141 7.20398 17.3058 7.37313C16.9995 7.5 16.6112 7.5 15.8346 7.5H4.16797C3.3914 7.5 3.00312 7.5 2.69683 7.37313C2.28845 7.20398 1.96399 6.87952 1.79484 6.47114C1.66797 6.16485 1.66797 5.77657 1.66797 5Z"
                        className="stroke"
                        strokeWidth="1.6"
                      />
                      <path
                        className="fill"
                        d="M4.16536 10.8333C4.6256 10.8333 4.9987 10.4602 4.9987 9.99996C4.9987 9.53972 4.6256 9.16663 4.16536 9.16663C3.70513 9.16663 3.33203 9.53972 3.33203 9.99996C3.33203 10.4602 3.70513 10.8333 4.16536 10.8333Z"
                      />
                      <path
                        className="fill"
                        d="M4.16536 5.83329C4.6256 5.83329 4.9987 5.4602 4.9987 4.99996C4.9987 4.53972 4.6256 4.16663 4.16536 4.16663C3.70513 4.16663 3.33203 4.53972 3.33203 4.99996C3.33203 5.4602 3.70513 5.83329 4.16536 5.83329Z"
                      />
                      <path
                        className="fill"
                        d="M4.16536 15.8333C4.6256 15.8333 4.9987 15.4602 4.9987 15C4.9987 14.5397 4.6256 14.1666 4.16536 14.1666C3.70513 14.1666 3.33203 14.5397 3.33203 15C3.33203 15.4602 3.70513 15.8333 4.16536 15.8333Z"
                      />
                    </svg>

                    <span>Leave Configuration</span>
                  </Link>
                </li> */}
                <li className={isActiveReports ? "active" : ""}>
                  <Link to="/reports" className="navLink">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M0.714844 14.2857C0.714844 13.4967 1.35444 12.8572 2.14342 12.8572H4.28627C5.07525 12.8572 5.71484 13.4967 5.71484 14.2857V17.8572C5.71484 18.6462 5.07525 19.2857 4.28627 19.2857H2.14342C1.35444 19.2857 0.714844 18.6462 0.714844 17.8572V14.2857ZM4.28627 14.5715C4.28627 14.4137 4.15835 14.2857 4.00056 14.2857H2.42913C2.27134 14.2857 2.14342 14.4137 2.14342 14.5715V17.5715C2.14342 17.7292 2.27134 17.8572 2.42913 17.8572H4.00056C4.15835 17.8572 4.28627 17.7292 4.28627 17.5715V14.5715Z"
                        className="fill"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M7.14453 2.1428C7.14453 1.35383 7.7841 0.714233 8.5731 0.714233H10.716C11.505 0.714233 12.1445 1.35383 12.1445 2.1428V17.8571C12.1445 18.6461 11.505 19.2857 10.716 19.2857H8.5731C7.7841 19.2857 7.14453 18.6461 7.14453 17.8571V2.1428ZM10.716 2.42852C10.716 2.27073 10.588 2.1428 10.4302 2.1428H8.85882C8.70103 2.1428 8.5731 2.27073 8.5731 2.42852V17.5714C8.5731 17.7292 8.70103 17.8571 8.85882 17.8571H10.4302C10.588 17.8571 10.716 17.7292 10.716 17.5714V2.42852Z"
                        className="fill"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M13.5703 7.85716C13.5703 7.06818 14.2099 6.42859 14.9989 6.42859H17.1417C17.9307 6.42859 18.5703 7.06818 18.5703 7.85716V17.8572C18.5703 18.6462 17.9307 19.2857 17.1417 19.2857H14.9989C14.2099 19.2857 13.5703 18.6462 13.5703 17.8572V7.85716ZM17.1417 8.14287C17.1417 7.98509 17.0138 7.85716 16.856 7.85716H15.2846C15.1268 7.85716 14.9989 7.98509 14.9989 8.14287V17.5714C14.9989 17.7292 15.1268 17.8572 15.2846 17.8572H16.856C17.0138 17.8572 17.1417 17.7292 17.1417 17.5714V8.14287Z"
                        className="fill"
                      />
                    </svg>

                    <span>Reports</span>
                  </Link>
                </li>
              </>
            ) : (
              <></>
            )}

            {user.role === "1" || user.role === "4" ? (
              <>
                <li className={isActiveCompanyHierarchy ? "active" : ""}>
                  <Link to="/companyHierarchy" className="navLink">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clipPath="url(#clip0_4731_3192)">
                        <path
                          d="M18.7097 16.129H18.5355C18.8432 15.7861 19.0323 15.3348 19.0323 14.8387C19.0323 13.8816 18.3332 13.0868 17.4194 12.9323V10.3226H10.3226V8.3871H13.2258V5.48387C13.2258 4.59452 12.5023 3.87097 11.6129 3.87097H11.5771C11.9968 3.46064 12.2581 2.88968 12.2581 2.25806C12.2581 1.0129 11.2448 0 10 0C8.75516 0 7.74194 1.0129 7.74194 2.25806C7.74194 2.88968 8.00323 3.46064 8.4229 3.87097H8.3871C7.49774 3.87097 6.77419 4.59452 6.77419 5.48387V8.3871H9.67742V10.3226H2.58065V12.9323C1.66677 13.0868 0.967742 13.8816 0.967742 14.8387C0.967742 15.3348 1.15677 15.7861 1.46452 16.129H1.29032C0.57871 16.129 0 16.7077 0 17.4194V20H5.80645V17.4194C5.80645 16.7077 5.22774 16.129 4.51613 16.129H4.34194C4.64968 15.7861 4.83871 15.3348 4.83871 14.8387C4.83871 13.8816 4.13968 13.0868 3.22581 12.9323V10.9677H9.67742V12.9323C8.76355 13.0865 8.06452 13.8813 8.06452 14.8387C8.06452 15.3348 8.25355 15.7861 8.56129 16.129H8.3871C7.67548 16.129 7.09677 16.7077 7.09677 17.4194V20H12.9032V17.4194C12.9032 16.7077 12.3245 16.129 11.6129 16.129H11.4387C11.7465 15.7861 11.9355 15.3348 11.9355 14.8387C11.9355 13.8816 11.2365 13.0868 10.3226 12.9323V10.9677H16.7742V12.9323C15.8603 13.0865 15.1613 13.8813 15.1613 14.8387C15.1613 15.3348 15.3503 15.7861 15.6581 16.129H15.4839C14.7723 16.129 14.1935 16.7077 14.1935 17.4194V20H20V17.4194C20 16.7077 19.4213 16.129 18.7097 16.129ZM4.51613 16.7742C4.87194 16.7742 5.16129 17.0635 5.16129 17.4194V19.3548H4.51613V17.7419H3.87097V19.3548H1.93548V17.7419H1.29032V19.3548H0.645161V17.4194C0.645161 17.0635 0.934516 16.7742 1.29032 16.7742H4.51613ZM4.19355 14.8387C4.19355 15.5503 3.61484 16.129 2.90323 16.129C2.19161 16.129 1.6129 15.5503 1.6129 14.8387C1.6129 14.1271 2.19161 13.5484 2.90323 13.5484C3.61484 13.5484 4.19355 14.1271 4.19355 14.8387ZM8.3871 2.25806C8.3871 1.36871 9.11065 0.645161 10 0.645161C10.8894 0.645161 11.6129 1.36871 11.6129 2.25806C11.6129 3.14742 10.8894 3.87097 10 3.87097C9.11065 3.87097 8.3871 3.14742 8.3871 2.25806ZM11.6129 16.7742C11.9687 16.7742 12.2581 17.0635 12.2581 17.4194V19.3548H11.6129V17.7419H10.9677V19.3548H9.03226V17.7419H8.3871V19.3548H7.74194V17.4194C7.74194 17.0635 8.03129 16.7742 8.3871 16.7742H11.6129ZM11.2903 14.8387C11.2903 15.5503 10.7116 16.129 10 16.129C9.28839 16.129 8.70968 15.5503 8.70968 14.8387C8.70968 14.1271 9.28839 13.5484 10 13.5484C10.7116 13.5484 11.2903 14.1271 11.2903 14.8387ZM8.70968 7.74194V5.80645H8.06452V7.74194H7.41935V5.48387C7.41935 4.95032 7.85355 4.51613 8.3871 4.51613H11.6129C12.1465 4.51613 12.5806 4.95032 12.5806 5.48387V7.74194H11.9355V5.80645H11.2903V7.74194H8.70968ZM17.0968 13.5484C17.8084 13.5484 18.3871 14.1271 18.3871 14.8387C18.3871 15.5503 17.8084 16.129 17.0968 16.129C16.3852 16.129 15.8065 15.5503 15.8065 14.8387C15.8065 14.1271 16.3852 13.5484 17.0968 13.5484ZM19.3548 19.3548H18.7097V17.7419H18.0645V19.3548H16.129V17.7419H15.4839V19.3548H14.8387V17.4194C14.8387 17.0635 15.1281 16.7742 15.4839 16.7742H18.7097C19.0655 16.7742 19.3548 17.0635 19.3548 17.4194V19.3548Z"
                          fill="white"
                        />
                        <path
                          d="M11.9342 11.6133H11.2891V12.2584H11.9342V11.6133Z"
                          fill="white"
                        />
                        <path
                          d="M13.2272 11.6133H12.582V12.2584H13.2272V11.6133Z"
                          fill="white"
                        />
                        <path
                          d="M14.5163 11.6133H13.8711V12.2584H14.5163V11.6133Z"
                          fill="white"
                        />
                        <path
                          d="M15.8053 11.6133H15.1602V12.2584H15.8053V11.6133Z"
                          fill="white"
                        />
                        <path
                          d="M4.84047 11.6133H4.19531V12.2584H4.84047V11.6133Z"
                          fill="white"
                        />
                        <path
                          d="M6.12954 11.6133H5.48438V12.2584H6.12954V11.6133Z"
                          fill="white"
                        />
                        <path
                          d="M7.4186 11.6133H6.77344V12.2584H7.4186V11.6133Z"
                          fill="white"
                        />
                        <path
                          d="M8.71157 11.6133H8.06641V12.2584H8.71157V11.6133Z"
                          fill="white"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_4731_3192">
                          <rect width="20" height="20" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>

                    <span>Company Hierarchy</span>
                  </Link>
                </li>
              </>
            ) : null}
          </ul>
          <div className="logout-flex">
            <Link to={"/grievances"}>
              <div className="logout-btn">
                <svg
                  width="26"
                  height="26"
                  viewBox="0 0 26 26"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11.3756 9.75024C11.3756 11.246 10.5268 12.4586 9.47979 12.4586C8.43278 12.4586 7.58398 11.246 7.58398 9.75024L9.75064 7.06934C10.6694 7.25708 11.3756 8.38583 11.3756 9.75024ZM14.6256 9.75024C14.6256 8.38583 15.3319 7.25708 16.2506 7.06934L18.4173 9.75024C18.4173 11.246 17.5685 12.4586 16.5215 12.4586C15.4744 12.4586 14.6256 11.246 14.6256 9.75024ZM9.47979 16.2502H15.4381C16.186 16.2502 16.7923 16.8565 16.7923 17.6044C16.7923 18.3523 16.186 18.9586 15.4381 18.9586H9.47979C8.73192 18.9586 8.12564 18.3523 8.12564 17.6044C8.12564 16.8565 8.73192 16.2502 9.47979 16.2502ZM19.2298 17.3062C17.334 16.7919 19.0493 13.7133 18.959 11.9169C21.1256 14.5978 21.6673 17.3336 19.2298 17.3062Z"
                    fill="white"
                  />
                </svg>
                <span>Grievances</span>
              </div>
            </Link>
            <Link to={"/helpDesk"}>
              <div className="logout-btn">
                <svg
                  width="26"
                  height="26"
                  viewBox="0 0 26 26"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.87891 9.4954C9.12561 8.7352 9.5779 8.05815 10.1855 7.53891C10.793 7.01965 11.5321 6.67876 12.3214 6.55352C13.1108 6.42828 13.92 6.52386 14.6585 6.82955C15.3969 7.13524 16.0357 7.6393 16.5057 8.28581C16.9755 8.93231 17.2576 9.69592 17.3204 10.4927C17.3833 11.2894 17.224 12.0879 16.8612 12.8C16.4984 13.5122 15.9465 14.1105 15.2649 14.5282C14.5835 14.9458 13.7998 15.1669 13.0007 15.1669V16.2498M13.0546 20.5833V20.6917L12.9467 20.6919V20.5833H13.0546Z"
                    stroke="white"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <span>Help Desk</span>
              </div>
            </Link>
            <div className="logout-btn" onClick={handleLogout}>
              <svg
                width="26"
                height="26"
                viewBox="0 0 26 26"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16.2487 4.33398H19.4987C20.6953 4.33398 21.6654 5.30403 21.6654 6.50065V19.5006C21.6654 20.6973 20.6953 21.6673 19.4987 21.6673H16.2487M8.66536 8.66732L4.33203 13.0007M4.33203 13.0007L8.66536 17.334M4.33203 13.0007H17.332"
                  stroke="white"
                  strokeWidth="1.75"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <span>Logout</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
